import React from "react";

const LoadingIcon = () => {
    return (<div className="loading-spinner"></div>);
}

export default LoadingIcon